import { Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { useContatosContext } from '../../../../../contexts/ContatosContexto';
import FormSelectExpedidorRecebedor from '../../components/FormSelectExpedidorRecebedor';
import { Card, ColCard, Switch as SwitchAntd, Title } from '../../styles';
import { FormItem, GlobalStyle } from './styles';

export default function StepExpedidor({
  clienteExpedidor,
  setClienteExpedidor,
  clienteEnderecoRemetente,
  hasContrato,
  isExpedidorIgualRemetente,
  setIsExpedidorIgualRemetente,
  setAlertMessageErrors,
  dadosPagador,
}) {
  const { removeContatoAction } = useContatosContext();
  const changeIsExpedidorIgualRemetente = value => {
    setIsExpedidorIgualRemetente(value);
    if (value) {
      if (clienteExpedidor) {
        const emails = clienteExpedidor.flatMap(cli => cli.clienteEmails);
        if (emails) {
          emails.forEach(email => {
            if (email) {
              removeContatoAction(email);
            }
          });
        }
      }

      const newClientes = clienteExpedidor;
      const clientesAtualizados = [];
      clienteEnderecoRemetente.forEach(cliente => {
        if (
          newClientes.filter(
            newCliente =>
              newCliente?.idClienteEndereco !== cliente.idClienteEndereco
          )
        ) {
          clientesAtualizados.push(cliente);
        }
      });
      setClienteExpedidor(clientesAtualizados);
      return;
    }

    const newClienteExpedidor = clienteExpedidor.filter(cliente => {
      for (let index = 0; index < clienteEnderecoRemetente.length; index++) {
        const remetente = clienteEnderecoRemetente[index];
        if (remetente.idClienteEndereco !== cliente.idClienteEndereco) {
          return false;
        }
      }
    });
    setClienteExpedidor(newClienteExpedidor);
  };

  const handleClienteExpedidor = () => {
    if (clienteEnderecoRemetente) {
      clienteExpedidor.filter(cliente => {
        for (let index = 0; index < clienteEnderecoRemetente.length; index++) {
          const remetente = clienteEnderecoRemetente[index];
          if (
            remetente.idClienteEndereco === cliente.idClienteEndereco &&
            clienteEnderecoRemetente.length === clienteExpedidor.length
          ) {
            setIsExpedidorIgualRemetente(true);
          } else {
            setIsExpedidorIgualRemetente(false);
          }
        }
      });
    }
  };

  useEffect(() => {
    async function onChangeIgual() {
      if (clienteExpedidor.length === 0) {
        setIsExpedidorIgualRemetente(false);
      }
      handleClienteExpedidor();
    }
    onChangeIgual();
  }, [isExpedidorIgualRemetente, clienteExpedidor]);

  useEffect(() => {
    async function onInit() {
      handleClienteExpedidor();
    }
    onInit();
  }, []);

  return (
    <>
      <GlobalStyle />
      <Row style={{ height: '90%' }}>
        <ColCard span={12} className="height-71">
          <Card className="height-71">
            <Row>
              <Title>Expedidor</Title>
              <FormItem
                name="isExpedidorIgualRemetente"
                label="Expedidor igual ao remetente"
                labelAlign="right"
                className="mb-5"
              >
                <SwitchAntd
                  disabled={hasContrato}
                  defaultChecked
                  size="default"
                  checked={isExpedidorIgualRemetente}
                  onChange={changeIsExpedidorIgualRemetente}
                />
              </FormItem>
            </Row>
            <FormSelectExpedidorRecebedor
              label="Meus endereços"
              clienteExpedidorRecebedor={clienteExpedidor}
              setClienteExpedidorRecebedor={setClienteExpedidor}
              setAlertMessageErrors={setAlertMessageErrors}
              disabled={hasContrato}
              tipo="Expedidor"
              dadosPagador={dadosPagador}
              clienteEnderecoRemetente={clienteEnderecoRemetente}
            />
          </Card>
        </ColCard>
      </Row>
    </>
  );
}

StepExpedidor.propTypes = {
  clienteExpedidor: PropTypes.arrayOf(PropTypes.any).isRequired,
  setClienteExpedidor: PropTypes.func.isRequired,
  clienteEnderecoRemetente: PropTypes.arrayOf(PropTypes.any).isRequired,
  hasContrato: PropTypes.bool.isRequired,
  isExpedidorIgualRemetente: PropTypes.bool.isRequired,
  setIsExpedidorIgualRemetente: PropTypes.func.isRequired,
  setAlertMessageErrors: PropTypes.func.isRequired,
  dadosPagador: PropTypes.shape({
    id: PropTypes.number,
    id_cliente_endereco: PropTypes.number,
    bairro: PropTypes.string,
    cep: PropTypes.string,
    cidade: PropTypes.string,
    cnpj: PropTypes.string,
    endereco: PropTypes.string,
    uf: PropTypes.string,
    razao_social: PropTypes.string,
    id_cidade: PropTypes.number,
    ibge_cidade: PropTypes.number,
    id_estado: PropTypes.number,
    clienteEmails: PropTypes.arrayOf(PropTypes.any),
  }),
};

StepExpedidor.defaultProps = {
  dadosPagador: null,
};
